module.exports = __webpack_public_path__ + "static/media/notificaciones.652b5a4d.svg";